import React from 'react';
import {Stack, Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import type {ProtocolItemContentProps} from './types';

const {provider: providerLabel, fiscalDocNumber: fiscalDocNumberLabel} =
	translations['pt-br'].privateFlow.refund.additionalDocuments.searchProtocol.protocolItemAccordion;

export function ProtocolItemContent({providerName, fiscalDocNumber}: ProtocolItemContentProps) {
	return (
		<Stack gap="16px" pt="16px">
			<Stack>
				<Typography variant="body2" color="text.secondary">
					{providerLabel}
				</Typography>
				<Typography variant="body1">{formatText(providerName)}</Typography>
			</Stack>
			<Stack>
				<Typography variant="body2" color="text.secondary">
					{fiscalDocNumberLabel}
				</Typography>
				<Typography variant="body1">{fiscalDocNumber}</Typography>
			</Stack>
		</Stack>
	);
}
